import { useCallback } from 'react';

import { useQueryClient } from '@zg-rentals/react-query5';
import { RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent_queryOptions } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import type {
  CheckDiscriminatoryContentResponseV2WebDto,
  ListingAlias,
} from '@zg-rentals/ts-rental-manager-api-client';

export const PLEDGE_VIOLATION_MESSAGE =
  'This language is not permitted under Zillow’s Respectful Renting Pledge. Edit the description to continue.';

/**
 * Imperative pledge check for use in a save path. The generated client exposes a query rather than a
 * mutation, so fetchQuery is what lets it run on demand while still caching by text.
 */
export const useCheckDiscriminatoryContent = () => {
  const queryClient = useQueryClient();

  return useCallback(
    ({ listingAlias, text }: { listingAlias: ListingAlias; text: string }) =>
      queryClient.fetchQuery<CheckDiscriminatoryContentResponseV2WebDto>({
        ...RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent_queryOptions({
          listingAlias,
          text,
        }),
        meta: {
          context: { api: 'rental-manager-api', details: 'useCheckDiscriminatoryContent' },
        },
      }),
    [queryClient],
  );
};
